
import { TableRow, ClickEvent, DataSourceMode, SlideoutDecorator, Button, DataSourceModeChangeEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutCarrierScorecardProfile } from "./autogen/AutogenLayoutCarrierScorecardProfile";
import { CarrierScorecardProfileDetail } from "./CarrierScorecardProfileDetail";
import { SingleActive } from "@mcleod/general";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { LinkedModel, ModelRow } from "@mcleod/core/src/ModelRow";
import { ValidationUtil } from "@mcleod/components/src/databinding/ValidationUtil";


const viewProfileUrl = "lme/powerbroker/CarrierScorecardProfile?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "carrier_performance_profile",
    screenName: "Carrier Scorecard Profile",
    navigateToUrl: viewProfileUrl
}

export class CarrierScorecardProfile extends AutogenLayoutCarrierScorecardProfile {
    onLoad(): void | Promise<void> {
        this.tableCarrierScorecardProfiles.onEditLayoutLoaded = (decorator, tableRow) => {
            const carrierScoreCardProfileDetail = decorator.layout as CarrierScorecardProfileDetail;
            decorator.multiButton.dropdownItems = null;
            const isSearch = this.mainDataSource.mode === DataSourceMode.SEARCH;
            if (isSearch) {
                decorator.labelTitle.text = 'Search Carrier Scorecard Profile Details'
            }
            decorator.multiButton.caption =  (isSearch)
                ? 'Apply Filters'
                : 'Apply Edits';
            
            decorator.onValidate = (updatedData: ModelRow | any) => {
                const results = [carrierScoreCardProfileDetail.validateMetricFields(updatedData)];
                if (results[0]) {
                    ValidationUtil.showFailedValidationDialog(
                        results, 
                        "Unable to save this record because data is missing or invalid.",
                        carrierScoreCardProfileDetail.mainDataSource
                    );
                    return results;
                } else {
                    return [];
                }
            }
            
            decorator.doAfterSlideOut = (_) => {
                tableRow.displayComponentValues();
            }
        }
        this.mainDataSource.doBeforeDataSourcePost = async (): Promise<boolean> => {
            let continueSave = true;
            if (this.mainDataSource.mode === DataSourceMode.ADD) {
                continueSave = await DuplicateId.validate(this.textboxProfileName, DUPLICATE_VALIDATION_PROPS);
            }
            return continueSave && await SingleActive.checkIfAnotherActive("carrier_performance_profile", "is_active", this.mainDataSource);
        }

        SingleActive.configureActiveFlag({
            tableName: "carrier_performance_profile", 
            activeFlag: "is_active", 
            datasource: this.mainDataSource
        });
        DuplicateId.setupValidateOnBlur(this.textboxProfileName, DUPLICATE_VALIDATION_PROPS);
    }

    tableRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        tableRow.showEditLayout();
    }

    buttonAddOnClick(event: ClickEvent) {
            const saveButton = this.createSaveButton();
            SlideoutDecorator.decorateAndSlideIn('lme/powerbroker/CarrierScorecardProfileDetail', {
                fillVerticalSpace: true,
                width: '50%',
                title: 'Add Carrier Scorecard Detail',
                overlayProps: { closeOnClickOff: false, greyedBackground: true },
                addlComponents: saveButton,
                layoutLoadListeners: async (event) => {
                    const layout = event.target as CarrierScorecardProfileDetail;
                    layout.mainDataSource.setRowsAndMode(DataSourceMode.ADD, [await layout.mainDataSource.createBlankRow()]);
                },
                doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                    saveButton.addClickListener(event => {
                        saveButton.busy = true;
                        if (decorator.layout.mainDataSource.validate()) {
                            const carrierScorecardProfileDetail = decorator.layout as CarrierScorecardProfileDetail;
                            const carrierScorecardProfileDetailRow = carrierScorecardProfileDetail.activeRow;
                            decorator.slideOut();
                            this.tableCarrierScorecardProfiles.addRow(carrierScorecardProfileDetailRow, null, { display: true, addToData: true });
                        }
                        saveButton.busy = false;
                    });
                }
            });
        }

    buttonSearchDetailsOnClick(event: ClickEvent) {
        const tableRow = this.tableCarrierScorecardProfiles.allRows[0]
        tableRow.showEditLayout();
    }

    createSaveButton() {
            return new Button({
                id: "buttonAddTopmatchProfile",
                caption: "Add Detail",
                backgroundColor: "primary",
                minWidth: 128,
                borderWidth: 0,
                rowBreak: false,
                default: true
            });
    }

    sourceCarrierScorecardProfileAfterModeChange(event: DataSourceModeChangeEvent) {
        this.buttonAddDetail.visible = event.newMode !== DataSourceMode.SEARCH;
        this.buttonSearchDetails.visible = event.newMode === DataSourceMode.SEARCH;
        if (event.oldMode === DataSourceMode.ADD && event.newMode === DataSourceMode.UPDATE) {
            const childLinks: LinkedModel[] = this.sourceCarrierScorecardProfile.activeRow?.data["_child_links"];
            childLinks?.forEach(linkedModel => linkedModel.rows?.forEach(row => row._appending = false));
        }
    }
}
